import React, { memo, useMemo } from 'react';
import CaptionMC from './CaptionMC';
import MessageStatusMC from './MessageStatusMC';
import GroupSenderMC from './GroupSenderMC';
import { formatText } from '../../../../util/textUtil';
import VideoMC from '../../../components/VideoMC';

/**
 * VideoMessageMC - Componente para mostrar un mensaje de video en el Inbox.
 */
const VideoMessageMC = memo(({ conversation, message }) => {
  const caption = useMemo(
    () => formatText(message?.contentMediaCaption || ''),
    [message?.contentMediaCaption]
  );

  return (
    <>
      <GroupSenderMC message={message} />
      <div className="tw-relative tw-w-full tw-overflow-hidden tw-p-1 tw-mb-1">
        <VideoMC
          platform={conversation.platform}
          data={message}
          className="tw-block tw-w-full tw-h-auto tw-max-h-[200px] tw-object-contain tw-rounded-[9px] tw-overflow-hidden tw-border-[#E4E4E4]"
        />
        <MessageStatusMC isMedia message={message} platform={conversation.platform} containerClassName="!tw-text-white !tw-mb-1" />
      </div>
      <CaptionMC caption={caption} />
    </>
  );
});

VideoMessageMC.displayName = 'VideoMessageMC';

export default VideoMessageMC;
